/**
 * Why this trip_stop terminated short of a successful delivery. Was
 * previously inferred by inspecting the (free-text) `refusalReason`
 * field plus the `customerRefused` boolean — which made filtering
 * "only refusals" vs "only skips" require string-matching the labels.
 *
 * F-4 (2026-05-24): split the discriminator out into its own enum so
 * reports + filters can cleanly partition the populations without
 * peeking at reason text:
 *
 * - `refusal` — driver arrived, attempted delivery, customer refused
 *   (typically signed-acknowledgment or no-funds situations). Pairs
 *   with `customerRefused = true`.
 * - `skip`    — driver chose not to attempt the stop (wrong address,
 *   construction blocking access, store closed, etc.). Driver-initiated
 *   skip flow at arrival time.
 * - `failure` — non-skip non-refusal failure (cargo damaged, truck
 *   broke down, etc.). Free-form failure reason text.
 *
 * The reason text itself stays in {@link TripStopEntity.terminationReason}
 * (renamed from `refusalReason`) and is still admin-list-driven via
 * `DistributionConfigPreferences.skipStopReasons` for skip-type
 * terminations.
 */
export enum TripStopTerminationTypeEnum {
	REFUSAL = 'refusal',
	SKIP = 'skip',
	FAILURE = 'failure',
}
